import React from "react";
import "./index.css";

export default function Menu({ url }) {
  const handleClick = () => {
    if (url) {
      window.location.href = url;
    }
  };

  return (
    <>
      <button onClick={handleClick} className="button_shopee">
        <span className="button-inner">
          <img src="./menu/xtra.png" alt="shopee1" />
        </span>
      </button>
      <button onClick={handleClick} className="button_shopee">
        <span className="button-inner">
          <img src="./menu/freeshipextra.png" alt="shopee1" />
        </span>
      </button>
      <button onClick={handleClick} className="button_shopee">
        <span className="button-inner">
          <img src="./menu/choice.png" alt="shopee1" />
        </span>
      </button>
      <button onClick={handleClick} className="button_shopee">
        <span className="button-inner">
          <img src="./menu/khunggio.png" alt="shopee1" />
        </span>
      </button>
      <button onClick={handleClick} className="button_shopee">
        <span className="button-inner">
          <img src="./menu/magg.png" alt="shopee1" />
        </span>
      </button>
      <button onClick={handleClick} className="button_shopee">
        <span className="button-inner">
          <img src="./menu/sieure.png" alt="shopee1" />
        </span>
      </button>
      <button onClick={handleClick} className="button_shopee">
        <span className="button-inner">
          <img src="./menu/style.png" alt="shopee1" />
        </span>
      </button>
      <button onClick={handleClick} className="button_shopee">
        <span className="button-inner">
          <img src="./menu/quocte.png" alt="shopee1" />
        </span>
      </button>
    </>
  );
}
